import { useContext } from 'react';
import SharedData from 'src/context/sharedData/sharedDataContext.jsx';

const useSharedData = () => {
  return useContext(SharedData);
};

export default useSharedData;
